import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { Employee } from '../entities/employee';
import { ResponsePageable } from '../../shared/_utils/services/responsePageable';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class EmployeeService extends BaseCrudService<Employee> {

  public uri = '/api/employee/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance EmployeeService');
  }

  buildSentence(entity?: Employee, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = entity.code ? 'code'
        + QueryOperator.Contain + entity.code
        + QueryOperator.Split : QueryOperator.Empty;
      query = query.concat(
        entity.firstLastName ? 'firstLastName'
          + QueryOperator.Contain + entity.firstLastName
          + QueryOperator.Split : QueryOperator.Empty
      );
      query = query.concat(
        entity.secondLastName ? 'secondLastName'
          + QueryOperator.Contain + entity.secondLastName
          + QueryOperator.Split : QueryOperator.Empty
      );
      query = query.concat(
        entity.secondLastName ? 'name'
          + QueryOperator.Contain + entity.name
          + QueryOperator.Split : QueryOperator.Empty
      );
      query = query.concat(
        entity.birthDate ? 'birthDate'
          + QueryOperator.Contain + entity.birthDate
          + QueryOperator.Split : QueryOperator.Empty
      );
      query = query.concat(
        entity.ruc ? 'ruc'
          + QueryOperator.Contain + entity.ruc
          + QueryOperator.Split : QueryOperator.Empty
      );
      if (entity.executingUnit && entity.executingUnit.id) {
        query = query.concat(
          `executingUnit.id${QueryOperator.Equal}${entity.executingUnit.id}${QueryOperator.Split}`
        );
      }
      if (entity.documentType && entity.documentType.id) {
        query = query.concat(
          `documentType.id${QueryOperator.Equal}${entity.documentType.id}${QueryOperator.Split}`
        );
      }
      if (entity.sex && entity.sex.id) {
        query = query.concat(
          `sex.id${QueryOperator.Equal}${entity.sex.id}${QueryOperator.Split}`
        );
      }
      if (entity.maritalStatus && entity.maritalStatus.id) {
        query = query.concat(
          `maritalStatus.id${QueryOperator.Equal}${entity.maritalStatus.id}${QueryOperator.Split}`
        );
      }
      if (entity.district && entity.district.id) {
        query = query.concat(
          `district.id${QueryOperator.Equal}${entity.district.id}${QueryOperator.Split}`
        );
      }
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

  // getSequenceCode(): Observable<string> {
  //     const url = this.rutaServidor + this.uri + 'maxCode/';
  //     return this.httpClient.get<any>(url)
  //         .pipe(
  //             map(response => {
  //                 // debugger;
  //                 const code = response.maxCode ? response.maxCode : FormatUtils.padLeftZero(0, 2);
  //                 const sequence = (parseInt(code, 10)) + 1;
  //                 return FormatUtils.padLeftZero(sequence, 2);
  //             }),
  //             tap(response =>  {
  //                //console.log(response);
  //             })
  //         );
  // }

  validateCreateEmployeeContract(employee): Observable<boolean> {
      const url = this.rutaServidor + this.uri + 'validateCreateEmployeeContract?id=' + employee.id;
         return this.httpClient.get<any>(url).pipe(
          tap(response => {
           /* if (response.numberOfElements > 0) {
              response.content.forEach((value) => {
                // debugger;
                this.convertToDate(value);
              })
            }
           //console.log('response search check here');
           //console.log(response);
            this.spinnerService.hideAll();*/
           //console.log(response);
            return response;
          })
        );
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/employee.service.ts